module.exports = __webpack_public_path__ + "assets/5395b1c016f7c5ec7de4fa81066a6924.png";